// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';

// IMPORT PROJECT REFERENCES
import { AnalysesListItem } from './AnalysesListItem';
import { PropTypes } from 'prop-types';

// COMPONENT
const renderList = analyses => (
    <div>
        <ul className="list-group list-group-flush">
            {analyses && analyses.length && analyses.map(analysis => renderListItem(analysis))}
        </ul>
    </div>
);

const renderListItem = analysis => (
    <Fragment key={`${analysis.id}`}>
        <li className="list-group-item">
            <AnalysesListItem {...analysis} />
        </li>
    </Fragment>
);

const AnalysesList = props => <Fragment>{renderList(props.analyses)}</Fragment>;

AnalysesList.propTypes = {
    analyses: PropTypes.array.isRequired,
};

export { AnalysesList };
